import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AppSharedModule } from '../../../../../../../app-shared.module';
import { BaseSectionComponent } from '../base-section';

@Component({
  selector: 'app-default-section',
  imports: [AppSharedModule],
  templateUrl: './default-section.component.html',
  styleUrl: './default-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultSectionComponent extends BaseSectionComponent {}
